import type { UUID } from '@cmg/common';
import { useCallback } from 'react';

import type { InvestorFirmRelationshipCreateInput } from '../../../../../../../../graphql';
import {
  useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
  useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
} from '../graphql/__generated__';

export function useCreateInvestorFirmSalesCoverageEmployeeRelationship(tenantId?: UUID) {
  const [createRelationshipsAsCustomer] =
    useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation();

  const [createRelationshipsAsAdmin] =
    useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation();

  return useCallback(
    async (input: InvestorFirmRelationshipCreateInput[]) => {
      if (tenantId) {
        return await createRelationshipsAsAdmin({
          variables: {
            input: {
              tenantId,
              input,
            },
          },
        });
      } else {
        return await createRelationshipsAsCustomer({ variables: { input } });
      }
    },
    [tenantId, createRelationshipsAsAdmin, createRelationshipsAsCustomer]
  );
}
